import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const useSavedBadge = (timeout = 2000) => {
  const [visible, setVisible] = React.useState(false);
  const timerRef = React.useRef(null);
  const audioCtxRef = React.useRef(null);

  const playFeedback = React.useCallback(() => {
    try {
      const C = window.AudioContext || window.webkitAudioContext;
      if (C) {
        if (!audioCtxRef.current) audioCtxRef.current = new C();
        const ctx = audioCtxRef.current;

        const playOsc = () => {
          try {
            const o = ctx.createOscillator();
            const g = ctx.createGain();
            o.type = 'sine';
            o.frequency.setValueAtTime(880, ctx.currentTime);
            g.gain.setValueAtTime(0.0001, ctx.currentTime);
            g.gain.linearRampToValueAtTime(0.18, ctx.currentTime + 0.02);
            o.connect(g);
            g.connect(ctx.destination);
            o.start();
            g.gain.linearRampToValueAtTime(0.0001, ctx.currentTime + 0.18);
            setTimeout(() => { try { o.stop(); } catch (e) {} }, 200);
          } catch (e) {
            // ignore
          }
        };

        // Some browsers require resume() be called as a result of a user gesture
        if (ctx.state === 'suspended' && typeof ctx.resume === 'function') {
          ctx.resume().then(playOsc).catch(playOsc);
        } else {
          playOsc();
        }
      }
    } catch (e) {
      // ignore audio errors
    }

    try {
      if (navigator && navigator.vibrate) navigator.vibrate(30);
    } catch (e) {}
  }, []);

  const trigger = React.useCallback(() => {
    setVisible(true);
    playFeedback();
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(false), timeout);
  }, [timeout, playFeedback]);

  React.useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  return [visible, trigger];
};

const SavedBadge = ({ visible, message = 'Enregistré', className = '' }) => {
  // Keep the element mounted for animation; use aria-live for screen readers
  return (
    <span aria-live="polite" className={`inline-flex items-center gap-2 ml-3 px-3 py-1 rounded-full bg-gradient-to-r from-emerald-500 to-emerald-600 text-white text-xs font-semibold shadow-lg transform transition-all duration-300 ${visible ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-75 -translate-y-1 pointer-events-none'} ${className}`}>
      <CheckCircle2 className="w-4 h-4" />
      <span>{message}</span>
    </span>
  );
};

export default SavedBadge;
